import { gql } from '@apollo/client/core';
import ExactPrice from './ExactPrice';
import PriceRange from './PriceRange';
// TODO: Consider using ProductPricing from Gatsby

export default function ProductPrice({ pricing, style, orientation }) {
  if (!hasContent(pricing)) return null;
  return pricing?.priceStrategy === 'BY_PRICE_RANGE'
    ? PriceRange({ pricing, style, orientation })
    : ExactPrice({ pricing, style, orientation });
}

ProductPrice.hasContent = hasContent;

function hasContent(pricing) {
  if (pricing?.priceStrategy === 'BY_PRICE' && pricing?.price != null)
    return true;
  if (
    pricing?.priceStrategy === 'BY_PRICE_RANGE' &&
    pricing?.priceRange != null
  )
    return true;
  return false;
}

ProductPrice.fragment = gql`
  fragment ProductPrice on RegisteredProduct {
    pricing {
      price
      currency
      currencyCode: currency(format: RAW)
      priceType
      bottleSize
      priceStrategy
      priceRange
    }
  }
`;
